import { EIP1193RequestFn, Transport } from 'viem';
import {
  abstract,
  arbitrum,
  base,
  baseSepolia,
  berachain,
  bsc,
  celo,
  hardhat,
  ink,
  lukso,
  mainnet,
  mode,
  monad,
  monadTestnet,
  optimism,
  polygon,
  sonic,
  zksync,
} from 'viem/chains';
import { createConfig, http } from 'wagmi';

import { hyperevm } from './viem';

export const config = createConfig({
  chains: [
    mainnet,
    polygon,
    arbitrum,
    abstract,
    optimism,
    bsc,
    base,
    celo,
    zksync,
    mode,
    baseSepolia,
    lukso,
    berachain,
    monadTestnet,
    sonic,
    hyperevm,
    ink,
    monad,
    ...(process.env.NEXT_PUBLIC_HARDHAT_NETWORK ? [hardhat] : []),
  ],
  multiInjectedProviderDiscovery: false,
  transports: {
    [mainnet.id]: http('https://ethereum-rpc.publicnode.com'),
    [polygon.id]: http(),
    [arbitrum.id]: http(),
    [abstract.id]: http(),
    [optimism.id]: http(),
    [bsc.id]: http(),
    [base.id]: http(),
    [celo.id]: http(),
    [zksync.id]: http(),
    [mode.id]: http(),
    [baseSepolia.id]: http(),
    [lukso.id]: http(),
    [berachain.id]: http(),
    [monadTestnet.id]: http(),
    [sonic.id]: http(),
    [hyperevm.id]: http(),
    [ink.id]: http(),
    [monad.id]: http(),
    ...(process.env.NEXT_PUBLIC_HARDHAT_NETWORK ? { [hardhat.id]: http() } : {}),
  } as Record<
    | 1
    | 137
    | 42161
    | 10
    | 56
    | 2741
    | 8453
    | 42220
    | 324
    | 34443
    | 84532
    | 31337
    | 10143
    | 42
    | 80094
    | 146
    | 999
    | 57073
    | 143,
    Transport<string, Record<string, any>, EIP1193RequestFn>
  >,
});
